import styled from 'styled-components';

const Link = styled.a`
  color: ${({ theme }) => theme.palette.accent.primary};
`;

export default Link;
